import script from "./BurtonOfficialDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./BurtonOfficialDashboard.vue?vue&type=script&setup=true&lang=js"

import "./BurtonOfficialDashboard.vue?vue&type=style&index=0&id=ae36a484&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae36a484"]])

export default __exports__